// A tela é da rota-pai (`admin.international-withdrawals.tsx`), porque ela continua
// desenhada embaixo quando o detalhe abre no drawer (`spec/24` §1 decisão 5). Esta
// rota-índice existe só pra `/admin/international-withdrawals` ser um destino válido.

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/international-withdrawals/')({
  component: () => null,
});
